<template>
    <div class="d-flex flex-column h-100" id="section-photo">
        <div class="shuffle-me shuffle-image-container">
            <div class="images">
                <img src="@/assets/images/gallery20.jpg" class="profile-image" />
                <img src="@/assets/images/gallery19.jpg" class="profile-image" />
            </div>
            <!-- <div class='shuffle-image-text'>Travellers</div> -->
        </div>
        <div class="margin-top-md text-center flex-grow-1 justify-content-center vertical-center">
            PostDoc Fellow @Harvard <br />
            Email: aoyuwu@seas.harvard.edu
            <a href="https://scholar.google.com/citations?user=-Vep07gAAAAJ&hl=en" class="url"
                >Google Scholar</a
            >
        </div>
    </div>
</template>

<script lang="ts">
import "bootstrap/dist/css/bootstrap.css";
import $ from "jquery";

import "./jquery.shuffle-images.js";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import { onMounted, computed, reactive, toRefs, h, watch } from "vue";

export default defineComponent({
    name: "App",
    components: {},
    setup() {
        const store = useStore();

        const state = reactive({
            svgStr: computed(() => store.state.svgStr),
        });

        onMounted(() => {
            ($(".shuffle-me") as any).shuffleImages({
                trigger: "imageMouseMove", // Choose which type of trigger you want here. Available options are "imageMouseMove", "imageHover", "documentMouseMove", and "documentScroll". "imageMouseMove" will trigger when your mouse over the image and move your cursor. "imageHover" will trigger when you mouse over without moving your cursor. "documentMouseMove" will trigger when cursor is being moved anywhere on the page. "documentScroll" will trigger when you scroll the page. The default value is "imageMouseMove"
                triggerTarget: false, // For "imageMouseMove", and "imageHover" only, you can set which element to trigger the image shuffle when mouse over. For example, if you want a container ".main" to trigger an image shuffle instead of the image itself, put $(".main") for this option. Default value is false.
                mouseMoveTrigger: 40, // For "imageMouseMove" only, you can set how many pixels you have to move in order to trigger one image shuffle. The lower the faster. The default value is 50.
                hoverTrigger: 200, // For "imageHover" only, you can set how long you have to hover the image until it shuffles to other images. The option accepts milliseconds without unit. The default value is 200.
                scrollTrigger: 100, // For "documentScroll" only, you can set how many pixels you have to scroll to see the image shuffle. The default value is 100.
                target: ".images > img", // In case you have a complete HTML structure, you can set your own custom selector to your images here. The default value is "> img" which means images that are directly under the "shuffle-me" will be used to shuffle.
            });
        });

        return {
            ...toRefs(state),
        };
    },
    computed: {},
});
</script>

<style rel="stylesheet" lang="scss">
.self-info-text {
    border: 1px solid black;
}

.shuffle-me img {
    border: 2px solid black;
}

.profile-image {
    object-fit: cover; /* Do not scale the image */
    object-position: center; /* Center the image within the element */
    height: 300px;
    width: 240px;

    display: block;
    margin-left: auto;
    margin-right: auto;
    // border-top-left-radius: 50% 50%;
    // border-top-right-radius: 50% 50%;
    // border-bottom-right-radius: 50% 50%;
    // border-bottom-left-radius: 50% 50%;
}

#section-photo {
    @media all and (min-width: 768px) {
        padding-top: 120px;
    }

    @media all and (max-width: 768px) {
        padding-top: 20px;
        padding-bottom: 20px;
    }
}
.shuffle-image-container {
    position: relative;
    text-align: center;
    color: white;

    .img-filter {
        opacity: 0.8;
        filter: opacity(0.9);
    }

    .shuffle-image-text {
        position: absolute;
        color: white;
        font-size: 2em;
        border-bottom: 4px solid #96351e;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

div.vertical-center {
    flex-direction: column;
    display: flex;
    align-items: center;
}
</style>
